import styled from 'styled-components';

export const TabPanelContainer = styled.div``;
